import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaCircleCheck, FaCheck } from "react-icons/fa6";
import Visionimg from "../../assets/images/visionimg.jpg";
import Missionimg from "../../assets/images/missionimg.jpg";
const VisionMission = () => {
  return (
    <section className="visionmission">
      <Container>
        <div className="section-title">
          <div className="sub-title">
            <FaCheck />
            <h4>Our Vision Mission</h4>
          </div>
          <h3 className="title">Driving Growth through Quality</h3>
        </div>
        <Row>
          <Col lg={6} md={12}>
            <div className="vissionmissiocard">
              <img src={Visionimg} alt="visionimg" loading="lazy" />
              <div className="vissionmissiocard-content">
                <h4 className="title">Our Vision</h4>
                <p className="description">
                  To become a trusted lifestyle brand that inspires confidence
                  and comfort in everyday living — both online and offline.
                </p>
                <ul>
                  <li> Seamless and secure shopping experience </li>
                  <li> Fast and reliable delivery </li>
                  <li> Easy and secure payment options </li>
                  <li> Quality products at competitive prices </li>
                </ul>
              </div>
            </div>
          </Col>
          <Col lg={6} md={12}>
            <div className="vissionmissiocard">
              <img src={Missionimg} alt="visionimg" loading="lazy" />
              <div className="vissionmissiocard-content">
                <h4 className="title">Our Mission</h4>
                <p className="description">
                  To make online shopping effortless and reliable by providing
                  premium quality products, fast and reliable delivery, and easy
                  and secure payment options.
                </p>
                <ul>
                  <li> Exceptional customer support </li>
                  <li> Great value for every purchase </li>
                  <li> Continuous innovation and improvement</li>
                  <li> Building long-term trust with every customer</li>
                </ul>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default VisionMission;
